import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface CompanySettings {
  id: string;
  companyName: string | null;
  logoDataUrl: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  updatedAt: string;
  updatedBy: string | null;
}

/**
 * `null` means the org hasn't saved anything yet — a normal, expected state
 * for a singleton row, not an error. Fetched once and cached at the session
 * lifetime, same idea as useSession: this is portal-wide chrome (header
 * logo/name), not something that changes mid-visit.
 */
export function useCompanySettings() {
  const query = useQuery({
    queryKey: ["company-settings"],
    queryFn: () => api<CompanySettings | null>("/api/v1/settings/company"),
    staleTime: 60_000,
  });

  return { settings: query.data, isLoading: query.isLoading };
}
